import React from "react";
import { FaDesktop, FaMicrochip, FaMemory, FaHdd, FaCheckCircle, FaTimesCircle } from "react-icons/fa";

function DesktopComputerDetails({ product }) {
    if (!product) return <p className="productspec-error">Məlumat tapılmadı.</p>;

    const getStatus = (val, yes = "Bəli", no = "Xeyr") =>
        val === true ? yes : val === false ? no : "Bilinmir";

    const specs = [
        { label: "Ad", value: product.name, icon: <FaDesktop /> },
        { label: "Şəhər", value: product.city },
        { label: "Kateqoriya", value: product.categoryName },
        { label: "Sub-kateqoriya", value: product.subCategoryName },
        { label: "Marka", value: product.brandName },
        { label: "Model", value: product.modelName },
        { label: "Prosessor", value: product.processor, icon: <FaMicrochip /> },
        { label: "RAM", value: product.ram ? `${product.ram} GB` : null, icon: <FaMemory /> },
        { label: "Disk növü", value: product.storageType, icon: <FaHdd /> },
        { label: "Disk həcmi", value: product.storage ? `${product.storage} GB` : null },
        { label: "Qrafik kart", value: product.gpu },
        { label: "Anakart", value: product.motherboard },
        { label: "Əməliyyat sistemi", value: product.operatingSystem },
        { label: "WiFi", value: getStatus(product.hasWiFi), status: product.hasWiFi },
        { label: "Bluetooth", value: getStatus(product.hasBluetooth), status: product.hasBluetooth },
        { label: "Çözünürlük", value: product.resolution },
        { label: "Yenilənmə tezliyi", value: product.refreshRate ? `${product.refreshRate} Hz` : null },
        { label: "Rəng", value: product.color },
        { label: "Zəmanət", value: getStatus(product.hasWarranty), status: product.hasWarranty },
        { label: "Vəziyyəti", value: product.condition },
        { label: "Enerji İstifadəsi", value: product.powerConsumption ? `${product.powerConsumption} W` : null }
    ];

    return (
        <div className="productspec-container productspec-container--electronics">
            <div className="productspec-header">
                <FaDesktop className="productspec-header__icon" />
                <h3 className="productspec-header__title">Masaüstü Kompüter Məlumatları</h3>
            </div>

            <div className="productspec-grid">
                {specs.map((spec, index) => {
                    if (!spec.value || spec.value === "Bilinmir") return null;
                    
                    return (
                        <div key={index} className="productspec-item">
                            {spec.icon && <span className="productspec-item__icon">{spec.icon}</span>}
                            <div className="productspec-item__content">
                                <span className="productspec-item__label">{spec.label}</span>
                                <span className={`productspec-item__value ${spec.status !== undefined ? (spec.status ? 'productspec-item__value--success' : 'productspec-item__value--neutral') : ''}`}>
                                    {spec.status !== undefined && (
                                        spec.status ? <FaCheckCircle className="productspec-status-icon productspec-status-icon--success" /> : <FaTimesCircle className="productspec-status-icon productspec-status-icon--neutral" />
                                    )}
                                    {spec.value}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>

            {product.description && (
                <div className="productspec-description">
                    <h4 className="productspec-description__title">Əlavə Təsvir</h4>
                    <p className="productspec-description__text">{product.description}</p>
                </div>
            )}
        </div>
    );
}

export default DesktopComputerDetails;